// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconCommonDiameter_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s8IconSvg = html `<svg viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M1.55468 5.73804L0.817993 6.47473L1.5251 7.18183L2.26176 6.44518C2.75218 6.79445 3.35216 6.99987 4.00012 6.99987C5.65698 6.99987 7.00012 5.65673 7.00012 3.99987C7.00012 3.35191 6.7947 2.75193 6.44543 2.26151L7.18195 1.52498L6.47485 0.817871L5.73829 1.55443C5.2479 1.20524 4.64799 0.999872 4.00012 0.999872C2.34327 0.999872 1.00012 2.34302 1.00012 3.99987C1.00012 4.64774 1.20549 5.24765 1.55468 5.73804ZM2.98403 5.7229C3.28181 5.89888 3.62917 5.99987 4.00012 5.99987C5.10469 5.99987 6.00012 5.10444 6.00012 3.99987C6.00012 3.62892 5.89913 3.28156 5.72315 2.98378L2.98403 5.7229ZM5.016 2.27672L2.27697 5.01575C2.10106 4.71802 2.00012 4.37073 2.00012 3.99987C2.00012 2.8953 2.89555 1.99987 4.00012 1.99987C4.37098 1.99987 4.71827 2.10081 5.016 2.27672Z" class="svg-bg"/>
</svg>
`;
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M7.99927 14.0002C11.313 14.0002 13.9993 11.3139 13.9993 8.00023C13.9993 4.68652 11.313 2.00023 7.99927 2.00023C4.68556 2.00023 1.99927 4.68652 1.99927 8.00023C1.99927 11.3139 4.68556 14.0002 7.99927 14.0002ZM7.99927 12.0002C10.2084 12.0002 11.9993 10.2094 11.9993 8.00023C11.9993 5.79109 10.2084 4.00023 7.99927 4.00023C5.79013 4.00023 3.99927 5.79109 3.99927 8.00023C3.99927 10.2094 5.79013 12.0002 7.99927 12.0002Z" class="svg-bg"/>
  <path d="M1.63599 12.9499L12.9497 1.63623L14.3639 3.05044L3.0502 14.3642L1.63599 12.9499Z" class="svg-bg"/>
</svg>
`;
/**
 * IconCommonDiameter is a generated icon component.
 */
let IconCommonDiameter = IconCommonDiameter_1 = class IconCommonDiameter extends IconBaseElement {
    render() {
        return html `${IconCommonDiameter_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconCommonDiameter.icons = new Map([
    ['s8', _s8IconSvg],
    ['s12', _s16IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s16IconSvg],
    ['s32', _s16IconSvg],
    ['s40', _s16IconSvg],
    ['s48', _s16IconSvg],
    ['s64', _s16IconSvg],
    ['s72', _s16IconSvg],
    ['s80', _s16IconSvg],
]);
IconCommonDiameter = IconCommonDiameter_1 = __decorate([
    customElement('zui-icon-common-diameter')
], IconCommonDiameter);
export { IconCommonDiameter };
